import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@maxgraph/core/css/common.css'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
